import type { IGTM } from 'api/types/searchPageApiTypes';
import type { NotificationFrequency } from 'components/SearchPage/hooks/useSavedSearch';
import { pushToDataLayer } from 'services/gtmService';

enum Events {
  SEARCH_PAGE = 'search-page',
  CREATE_SAVED_AD = 'create_saved_ad',
  DELETE_SAVED_AD = 'delete_saved_ad',
  CREATE_SAVED_SEARCH = 'create_saved_search',
}

const GTM_Alert_Types = {
  DAILY: 'daily_alerts',
  INSTANT: 'instant_alerts',
  OFF: 'no_alerts',
};

const useSearchPageGTM = (gtmData: IGTM) => {
  const pushData = (event: string, customData?: IGTM) => {
    if (customData) {
      pushToDataLayer({ ...gtmData, ...customData, event: [event] });
    } else {
      pushToDataLayer({ ...gtmData, event: [event] });
    }
  };

  const searchPageEvent = (data?: IGTM) => {
    pushData(Events.SEARCH_PAGE, data);
  };

  const createSavedAdEvent = (adId: number, data?: IGTM) => {
    pushData(Events.CREATE_SAVED_AD, { savedAdId: [adId], ...data });
  };

  const deleteSavedAdEvent = (data?: IGTM) => {
    pushData(Events.DELETE_SAVED_AD, data);
  };

  const createSavedSearchEvent = (
    alertType: keyof typeof NotificationFrequency,
    data?: IGTM,
  ) => {
    pushData(Events.CREATE_SAVED_SEARCH, {
      alertType: [GTM_Alert_Types[alertType]],
      ...data,
    });
  };

  return {
    searchPageEvent,
    createSavedAdEvent,
    deleteSavedAdEvent,
    createSavedSearchEvent,
  };
};

export { useSearchPageGTM };
